import styled, { css } from 'styled-components';
import { useGame } from '../providers/GameProvider/GameProvider';
import { Tube } from './layout/Tube';
import React from 'react';
import { DateChanger } from './DateChanger';

const ADMIN_MODE_ENABLED = false;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  margin: 0;
  gap: 2rem;

  @media (max-width: 630px) {
    padding: 0;
  }
`;

const Title = styled.p(
  ({ theme }) => css`
    color: ${theme.text.default};
    font-size: 1.5rem;
    font-weight: 700;
    text-align: center;
    margin: 0;

    @media (max-width: 630px) {
      font-size: 1.25rem;
    }
  `
);

const Count = styled.p(
  ({ theme }) => css`
    color: ${theme.text.default};
    font-size: 2rem;
    font-weight: 900;
    text-align: center;
    margin: 0;

    @media (max-width: 630px) {
      font-size: 1.5rem;
    }
  `
);

export function GuessCount() {
  const { guessCount, gameState } = useGame();
  const [adminMode, setAdminMode] = React.useState(false);

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('admin') === 'true') {
      setAdminMode(true);
    }
  }, []);

  return (
    <Container>
      <Tube align="center">
        <Title>Lives:</Title>
        <Count key={guessCount}>
          {gameState === 'continue' ? '-' : guessCount}
        </Count>
      </Tube>

      {adminMode && ADMIN_MODE_ENABLED && <DateChanger />}
    </Container>
  );
}
